import { useMediaQuery } from "@mui/material";

export const useMediaQueryHook = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );
  const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const isLaptopSized = useMediaQuery("(max-width:1540px)");

  return { isSmallScreen, isMediumScreen, isLargeScreen, isLaptopSized };
};
